import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function AuthGate({ children, title, description, icon = '🔐' }) {
  const loggedIn = !!localStorage.getItem('evapp_token');
  const location = useLocation();

  if (loggedIn) return children;

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)', paddingTop: 56,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, sans-serif', padding: '80px 16px',
    }}>
      <div style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: 20 }}>{icon}</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.4px', marginBottom: 10 }}>
          {title || 'Sign in required'}
        </h2>
        <p style={{ fontSize: 14, color: 'var(--text-3)', lineHeight: 1.65, marginBottom: 28 }}>
          {description || 'Create a free account to access this page.'}
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <Link to={`/login?next=${encodeURIComponent(location.pathname)}`} style={{
            padding: '11px 24px', borderRadius: 10, textDecoration: 'none',
            background: 'var(--teal)', color: '#F0F4FF', fontWeight: 700, fontSize: 14,
          }}>
            Sign In
          </Link>
          <Link to={`/login?next=${encodeURIComponent(location.pathname)}`} style={{
            padding: '11px 24px', borderRadius: 10, textDecoration: 'none',
            border: '1px solid var(--border-2)', color: 'var(--text-2)', fontSize: 14,
          }}>
            Create Account
          </Link>
        </div>
        <p style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 20 }}>
          Free forever · No credit card needed
        </p>
      </div>
    </div>
  );
}
